import ImagePageWrapper from "components/pages/ImagePageWrapper";
import { ForgottenPassword } from "features/System/ForgottenPassword";
import React from "react";

const ForgottenPasswordPage = () => {
  return (
    <ImagePageWrapper>
      <ForgottenPassword />
    </ImagePageWrapper>
  );
};

export default ForgottenPasswordPage;
